<template>
    <div>
            <b-row class="mt-5" v-show="!catchingComplete" v-if="raid && request">
                <b-col>
                    <div class="h4 mb-2">2. Исполнитель</div>
                    <common-event :kind="eventKind"
                                  :request="request"
                                  :selected-municipality="request.addressObject['municipality_object']"
                                  :catching-contract="request.contractObject"
                                  :editable="!catchingComplete"
                                  ref="commonEvent"
                                  class="mb-2" />
                </b-col>
            </b-row>

            <b-row class="mt-5" v-if="raid && request">
                <b-col sm="12">
                    <div class="mb-4">
                        <span class="h4 mr-3">3. Животные</span>
                        <span :class="{'text-secondary': !catchingComplete, 'text-success': catchingComplete}">
                            <b-icon icon="check2"  class="mr-2" v-if="catchingComplete" />
                            <small v-if="isCompletable">Отловлено {{ newEvents.length }} из {{ request.animalsCount }}</small>
                            <small v-else>Отловлено {{ newEvents.length }}</small>
                        </span>
                    </div>


                    <div v-if="newEvents.length">
                        <div class="d-flex flex-wrap mb-4 mt-2 col-xs-12 col-lg-8 p-0" v-if="raid">
                            <catching-existing-event v-for="(event, i) in groupedNewEvents.forRaid"
                                                     :key="i + 'catching-existing-event-raid'"
                                                     :event="event"
                                                     :removable="true"
                                                     @catching-existing-event-removed="removeExistingEvent"
                                                     class="mr-5 mb-3"/>
                            <catching-existing-event v-for="(event, i) in groupedNewEvents.forRequest"
                                                     :key="i + 'catching-existing-event-request'"
                                                     :event="event"
                                                     class="mr-5 mb-3"/>
                        </div>
                        <div class="d-flex flex-wrap mb-4 mt-2 col-xs-12 col-lg-8 p-0" v-else>
                            <catching-existing-event v-for="(event, i) in newEvents"
                                 :key="i + 'catching-existing-event'"
                                 :event="event"
                                 class="mr-5 mb-3"/>
                        </div>
                    </div>

                    <div v-if="request && raid" v-show="!catchingComplete">
                        <catching-animal ref="newAnimal" class="mb-3" :remaining-count="remainingCount()" />
                        <catching-attributes
                            :initial-data="{raid: raid}"
                            ref="newAttributes"
                            @files-uploaded="onFilesUploaded"/>
                        <b-row class="mt-3">
                            <b-col>
                                <b-button class="mt-3" variant="primary" @click="onSaveEvent(false)">
                                    <span v-if="isCompletable">
                                        <span v-if="newEvents.length === request.animalsCount - 1">Сохранить</span>
                                        <span v-else>Сохранить и добавить еще животное</span>
                                    </span>
                                    <span v-else>Сохранить и добавить еще животное</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </div>

                </b-col>
            </b-row>

            <div class="d-flex flex-column mt-3">
                <div class="flex-grow-1 mb-2 mb-sm-0">
                    <b-button variant="link" @click="backToRequest">
                        <b-icon icon="arrow-left" class="mr-2" />
                        <span>К заявке</span>
                    </b-button>
                </div>
            </div>

        </div>
</template>

<script>
import {eventFactory, EventKind} from "@/pages/AppPages/Events/event";
import api from "@/api";
import httpClient from "@/http";
import {Request} from "@/pages/AppPages/Requests/request";
import {Raid} from "@/pages/AppPages/Raids/raid";
import {Animal} from "@/pages/AppPages/Animals/animal";
import CatchingAnimal from "@/pages/AppPages/Events/Catching/CatchingAnimal.vue";
import CatchingAttributes from "@/pages/AppPages/Events/Catching/CatchingAttributes.vue";
import CatchingRaidDetail from "@/pages/AppPages/Events/Catching/CatchingRaidDetail.vue";
import CommonEvent from "@/pages/AppPages/Events/CommonEvent.vue";
import CatchingExistingEvent from "@/pages/AppPages/Events/Catching/CatchingExistingEvent.vue";

export default {
    name: "BaseCatchingBulkCreate",
    components: {CatchingExistingEvent, CommonEvent, CatchingRaidDetail, CatchingAttributes, CatchingAnimal},
    props: {
        raid: { type: null, default: null },
        isCompletable: { type: Boolean, default: true }
    },
    data() {
        return {
            eventKind: EventKind.CATCHING,
            newEvents: [],
            saving: false,
            bufferedAttachmentIds: [],
            request: null
        }
    },
    computed: {
        raidId() {
            return this.raid.id
        },
        requestId() {
            if (this.request) {
                return this.request.id;
            }
            if (this.raid) {
                return this.raid.request;
            }
            return null
        },
        groupedNewEvents() {
            let groupedNewEvents = {forRequest: [], forRaid: []};
            for (const event of this.newEvents) {
                if (event.raidId === this.raid.id) {
                    groupedNewEvents.forRaid.push(event)
                } else {
                    groupedNewEvents.forRequest.push(event)
                }
            }
            return groupedNewEvents;
        },
        catchingComplete() {
            if (!this.isCompletable) {
                return false
            }
            return this.request ? this.request.animalsCount - this.request.caughtCount > 0 && this.newEvents.length === this.request.animalsCount  : false
        }
    },
    methods: {
        backToRequest() {
            this.$router.replace({ name: 'requestsDetail', params: { id: this.requestId } } );
        },

        newAnimalExisting() {
            return this.$refs.newAnimal.existing
        },

        newSelectedAnimal() {
            return this.$refs.newAnimal.selectedAnimal
        },

        setNewSelectedAnimal(data) {
            this.$refs.newAnimal.selectedAnimal = data;
        },

        newAnimalPrepareData() {
            return this.$refs.newAnimal.prepareData();
        },

        newAttributesPrepareData() {
            return this.$refs.newAttributes.prepareData();
        },


        showNewAnimalErrorToast(error) {
            this.$refs.newAnimal.showErrorToast(error);
        },

        clearNewAnimalForm() {
            this.$refs.newAnimal.clearForm();
            this.$refs.newAnimal.fetchNextRegNumber();
        },

        commonEventPrepareData() {
            return this.$refs.commonEvent.prepareData();
        },

        showCommonEventErrorToast(error) {
            this.$refs.commonEvent.showErrorToast(error);
        },

        newAttributesClearFormAndGallery() {
            this.$refs.newAttributes.clearFormAndGallery();
        },

        remainingCount() {
            if (!this.isCompletable) { return null }
            return this.request.animalsCount - this.newEvents.length
        },

        fetchRequest() {
            const vm = this;
            return new Promise((resolve, reject) => {
                const requestUrl = api.requests.default.detail(vm.requestId);
                httpClient.get(requestUrl).then(response => {
                    vm.request = new Request();
                    vm.request.applyData(response.data);
                    resolve();
                }).catch(reason => {
                    vm.$bvToast.toast(reason, { title: 'Ошибка при получении информации о заявке с сервера', variant: 'danger'})
                    reject();
                });
            })
        },

        fetchExistingEvents() {
            const existingEventsUrl = api.events.default.list();
            httpClient.get(existingEventsUrl, { params: { request: this.requestId, kind: EventKind.CATCHING }}).then((response) => {
                for (const i in response.data.results) {
                    const data = response.data.results[i];
                    const objectClass = eventFactory(EventKind.CATCHING);
                    let newEvent = new objectClass();
                    newEvent.applyData(data);
                    this.newEvents.push(newEvent);
                }
            })
        },
        removeExistingEvent(eventId) {
            for (let i = 0; i < this.newEvents.length; i++) {
                const event = this.newEvents[i];
                if (event.id === eventId) {
                    this.newEvents.splice(i, 1);
                    this.$bvToast.toast('Мероприятие по отлову удалено', { variant: 'secondary', noCloseButton: true, solid: true });
                    break;
                }
            }
        },
        onFilesUploaded(uploadedIds) {
            this.bufferedAttachmentIds = [...this.bufferedAttachmentIds, ...uploadedIds.ids]
        },
        async getOrCreateAnimal() {
            if (this.newAnimalExisting()) {
                let newSelectedAnimal = this.newSelectedAnimal()
                if (newSelectedAnimal) {
                    return await new Promise(resolve => {
                        resolve(newSelectedAnimal)
                    });
                }
                return await new Promise(reject => {
                    reject('Не выбрано животное')
                })
            }
            const endpoint = api.animals.default.list();
            const data = this.newAnimalPrepareData()
            const response = await httpClient.post(endpoint, data);

            let animal = new Animal();
            animal.applyData(response.data);
            return animal;
        },
        async createEvent(animal, eventData) {
            if (!animal) {
                throw new Error('Не указано животное');
            }

            eventData['animal'] = animal.id;
            eventData['request'] = this.requestId;
            eventData['raid'] = this.raid.id;
            eventData['attributes'] = this.newAttributesPrepareData()

            const endpoint = api.events.default.list();
            const response = await httpClient.post(endpoint, eventData);

            const objectClass = eventFactory(EventKind.CATCHING);
            let newEvent = new objectClass();
            newEvent.applyData(response.data);

            this.setNewSelectedAnimal({})

            return newEvent
        },
        async onSaveEvent(shouldGoBack = false) {
            const vm = this;
            vm.saving = true;

            let animal = await this.getOrCreateAnimal().catch(error => {
                vm.showNewAnimalErrorToast(error)
                vm.saving = false;
            });

            if (!animal) {
                if (this.newAnimalExisting()) {
                    this.clearNewAnimalForm()
                }
                return
            }

            const eventData = this.commonEventPrepareData();
            eventData.attachments = this.bufferedAttachmentIds;
            let event = await this.createEvent(animal, eventData).catch(error => {
                vm.showCommonEventErrorToast(error)
                vm.saving = false;
            });

            if (event) {
                this.clearNewAnimalForm()
                vm.newEvents.push(event);

                if (shouldGoBack) {
                    this.$nextTick(() => {
                        this.$router.back()
                    });
                    return
                }

                vm.bufferedAttachmentIds = [];
                vm.newAttributesClearFormAndGallery();
                vm.saving = false;
                vm.$bvToast.toast('Мероприятие по отлову создано успешно', { variant: 'success', noCloseButton: true, solid: true })

            } else {
                if (this.newAnimalExisting()) {
                    this.clearNewAnimalForm()
                }
            }

        }
    },
    mounted() {
        const vm = this;
        vm.fetchRequest().then(() => {
            vm.fetchExistingEvents()
        })

    }
}
</script>

<style scoped>

</style>